import { TYPES } from '../../common/constants';

export const setItemFormData = payload => ({
  type: TYPES.SET_ITEM_FORM_DATA,
  payload,
});


export const clearItemFormData = () => ({
  type:TYPES.CLEAR_ITEM_FORM_DATA,
 })